import { useState } from 'react';
import DefaultImage from '../../../assets/images/DefaultImage.jpeg';


const MediaGallery = ({ images = [], promotion_videos = [], attachments = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const [showModal, setShowModal] = useState(false);

  const allMedia = [
    ...images.map((img) => ({ type: 'image', url: img.url })),
    ...promotion_videos.map((vid) => ({ type: 'video', url: vid.url })),
    ...attachments.map((pdf) => ({ type: 'pdf', url: pdf.url, name: pdf.name })),
  ];

  const renderMainMedia = () => {
    const media = allMedia[activeIndex];
    if (!media) return (
      <img
        src={DefaultImage}
        className="img-fluid rounded"
        style={{ width: '100%', maxHeight: '400px', objectFit: 'cover'}}
        alt="Default"
      />
    ); 

    if (media.type === 'image') {
      return (
        <img
          src={media.url}
          className="img-fluid rounded"
          alt="Media"
          style={{ width: '100%', maxHeight: '400px', objectFit: 'cover', cursor: 'pointer' }}
          onClick={() => setShowModal(true)}
        />
      );
    }

    if (media.type === 'video') {
    return (
      <video
        controls
        className="w-100 rounded"
        style={{ cursor: 'pointer', width: '100%', maxHeight: '400px', objectFit: 'cover' }}
        onClick={() => setShowModal(true)}
      >
        <source src={media.url} type="video/mp4" />
        Your browser does not support the video tag.
      </video>
    );
  }

  if (media.type === 'pdf') {
    return (
      <div
        onClick={() => window.open(media.url, '_blank')}
        className="border rounded p-3 text-center bg-light"
        style={{ cursor: 'pointer' }}
      >
        <span role="img" aria-label="pdf" style={{ fontSize: '2rem' }}>📄</span>
        <p className="mb-0">{media.name || 'PDF Attachment'}</p>
        <small className="text-muted">(Click to open in new tab)</small>
      </div>
    );
  }
    return null;
  };

  const renderModalContent = () => {
    const media = allMedia[activeIndex];
    if (!media) return null;

    if (media.type === 'image') {
      return <img src={media.url} className="img-fluid" style={{ maxHeight: '90vh' }} alt="Enlarged" />;
    }

    if (media.type === 'video') {
      return (
        <video controls className="w-100 rounded">
          <source src={media.url} type="video/mp4" />
        </video>
      );
    }

    if (media.type === 'pdf') {
      return (
        <iframe
          src={media.url}
          title="PDF Preview"
          style={{ width: '100%', height: '90vh', border: 'none' }}
        ></iframe>
      );
    }

    return null;
  };

  return (
    <div className="media-gallery container w-100 ">
      {/* Main Media */}
      <div className="d-flex justify-content-center align-items-center rounded" >
        {renderMainMedia()}
      </div>

      {/* Thumbnails */}
      <div className="d-flex overflow-auto mt-3 gap-2">
        {allMedia.map((media, index) => (
          <div
            key={index}
            className={`border rounded p-1 ${index === activeIndex ? 'border-primary' : ''}`}
            style={{ cursor: 'pointer', width: '80px', height: '80px' }}
            onClick={() => setActiveIndex(index)}
          >
            {media.type === 'image' ? (
              <img src={media.url} className="img-fluid h-100 w-100 object-fit-cover" alt={`Thumb ${index}`} />
            ) : media.type === 'video' ? (
              <video className="img-fluid h-100 w-100 object-fit-cover">
                <source src={media.url} type="video/mp4" />
              </video>
            ) : (
              <div className="d-flex justify-content-center align-items-center bg-light h-100 w-100">
                <span role="img" aria-label="pdf">📄</span>
              </div>
            )}
          </div>
        ))}
      </div>

      {/* Modal Viewer */}
      {showModal && (
        <div
          className="modal show fade"
          style={{ display: 'block', backgroundColor: 'rgba(0,0,0,0.85)' }}
          onClick={() => setShowModal(false)}
        >
          <div className="modal-dialog modal-dialog-centered modal-xl" onClick={(e) => e.stopPropagation()}>
            <div className="modal-content bg-transparent border-0">
              <div className="modal-body text-center position-relative">
                <button
                  className="btn-close btn-close-white position-absolute top-0 end-0 m-3"
                  onClick={() => setShowModal(false)}
                  aria-label="Close"
                ></button>
                {renderModalContent()}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaGallery;
